var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-optimiser-widget"},[_c('file-pond',{ref:"pond",attrs:{"name":"test","label-idle":"Drop files here...","files":_vm.files},on:{"init":_vm.filePondInit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }